module.exports = __webpack_public_path__ + "static/media/georgia-large.f297f32c.jpg";